// The v2 vocabularies this app uses (contracts/v2 on the backend; the
// fixture in __fixtures__/v2-contract.json carries the backend's full lists,
// and the reducer test checks every name here is one of them). Anything else
// the backend sends is ignored, so it can ship new types first.

export const HANDLED_EVENT_TYPES = [
  'session.upsert', 'session.remove', 'race.upsert', 'race.remove',
  'note.upsert', 'note.remove', 'training_event.upsert', 'training_event.remove',
  'change.applied', 'activity.linked', 'thread.item', 'checkin.upsert',
  'coach.text', 'coach.step', 'run.status',
  // M4: the strategy, its draft and the goal (strategy.js)
  'strategy.phase', 'week.outline', 'draft.session.upsert', 'draft.session.remove', 'draft.status',
  'coach.insight', 'goal.upsert',
  // the human-coach badge (aithlo-backend#167)
  'coaching.unread',
];

// Every thread item type the coach panel renders (spec §13.15, M5): one
// renderer each in components/v2/ThreadItem.jsx. A type not here renders nothing.
export const RENDERED_ITEM_TYPES = [
  'coach_message', 'athlete_message', 'working', 'change', 'proposal', 'plan_update', 'observation',
  'system_action', 'athlete_action', 'safety',
  'question',   // M4: the intake questions, answered with a tap
];

// A coach_message's `body.kind`; any other kind renders as a plain bubble.
// M6: 'on_track' (app/plan/trajectory.py) is a plain bubble too, and the race
// screen's latest word on that goal.
export const COACH_MESSAGE_KINDS = ['chat', 'request', 'reaction', 'morning_card', 'on_track',
  // A plan the coach couldn't build or apply, or is repairing (failures.js): a plain
  // bubble; body.actions ['rebuild'] adds Try again (POST /v2/plan/rebuild).
  'plan_failed', 'plan_not_applied', 'proposal_updating',
  // The coach's word on the athlete's own calendar edits (app/coach/reconcile review_edits): a plain bubble.
  'edit_comment'];

// A plan_update's `body.kind`: 'week_written' (M5) is the compact line;
// 'phase_review' (M6, app/coach/head/phase_review.py) is a card with Open timeline.
export const PLAN_UPDATE_KINDS = ['week_written', 'phase_review'];

// The on-track indicator (athlete_trajectory.status); none yet shows as missing.
export const ON_TRACK_STATUS_VALUES = ['on_track', 'ahead', 'behind'];

// The coach log (GET /v2/thread?filter=coach; app/thread/store.py COACH_ACTIONS).
export const COACH_ACTION_TYPES = ['change', 'proposal', 'plan_update', 'safety', 'system_action', 'observation'];

// A thread item's state (ThreadItemState).
export const ITEM_STATES = ['active', 'undone', 'accepted', 'dismissed', 'superseded'];

// What a phase is for (PhaseKind, D49): code reads the kind, the athlete reads the name.
export const PHASE_KINDS = ['base', 'build', 'race_specific', 'peak', 'taper', 'race', 'recovery', 'transition'];

// The athlete's one non-race goal (Goal.schema.json; a race is a race on the calendar).
export const GOAL_KINDS = [
  { value: 'fitness', label: 'General fitness' },
  { value: 'performance_target', label: 'A performance target' },
  { value: 'milestone', label: 'A milestone' },
  { value: 'maintain', label: 'Keep my fitness' },
  { value: 'return', label: 'Come back after injury or a break' },
];

// How the coach treats a race of each priority (spec §13.3).
export const RACE_PRIORITIES = [
  { value: 'A', label: 'A race', hint: 'Your target: the plan builds to it, with a full taper' },
  { value: 'B', label: 'B race', hint: 'Raced well inside a phase, with a short taper' },
  { value: 'C', label: 'C race', hint: 'A hard training day, no taper' },
];

